export type BoardInactiveDays = 0 | 7 | 14 | 30 | 90;

export function normalizeBoardInactiveDays(value: unknown): BoardInactiveDays {
  const days = Number(value);
  return days === 7 || days === 14 || days === 30 || days === 90 ? days : 0;
}

export function isInactiveSince(updatedAt: number, days: BoardInactiveDays, now = Date.now()): boolean {
  return days === 0 || updatedAt <= now - days * 86_400_000;
}

export function updatedAge(updatedAt: number, now = Date.now()): string {
  const days = Math.max(0, Math.floor((now - updatedAt) / 86_400_000));
  if (days === 0) return "Updated today";
  if (days === 1) return "Updated yesterday";
  return `Updated ${days} days ago`;
}
